import { BmHttp } from "../utils/Global";

// AUDITORIA-CLINICA-FASE-1 -- modulo READ-ONLY (ver context/37_AUDITORIA_
// CLINICA_FLUJO_GLOBAL_35.md). Los metodos Get* de este archivo solo llaman GET.
//
// AUDITORIA-CLINICA-FASE-2: `PostAuditoriaClinicaCorreccion` es el UNICO metodo
// de escritura -- POST /audit/clinical/appointments/:idcita/corrections,
// protegido en backend por `auditoria.clinica.correct`.

const buildListParams = ({ page, pageSize, filters = {} }) => ({
    page,
    pageSize,
    fecha_desde: filters.fecha_desde,
    fecha_hasta: filters.fecha_hasta,
    clinica: filters.clinica,
    paciente: filters.paciente,
    documento: filters.documento,
    doctor: filters.doctor,
    estado_cita: filters.estado_cita,
    cobertura: filters.cobertura,
    aseguradora: filters.aseguradora,
    plan: filters.plan,
    corregida: filters.corregida,
    // AUDITORIA-CLINICA-WORKFLOW-44: estado de REVISION (PENDIENTE/EN_PROCESO/
    // AUDITADA), distinto de `estado_cita` y de `corregida`.
    estado_auditoria: filters.estado_auditoria,
});

export const GetAuditoriaClinicaCitas = async ({ page = 1, pageSize = 20, filters }) => {
    try {
        const { data } = await BmHttp().get(`audit/clinical/appointments`, { params: buildListParams({ page, pageSize, filters }) });
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: [], message: "Error de red" };
    }
};

export const GetAuditoriaClinicaDetalle = async (idcita) => {
    try {
        const { data } = await BmHttp().get(`audit/clinical/appointments/${idcita}`);
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: null, message: "Error de red" };
    }
};

export const GetAuditoriaClinicaHistorial = async (idcita) => {
    try {
        const { data } = await BmHttp().get(`audit/clinical/appointments/${idcita}/history`);
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: [], message: "Error de red" };
    }
};

export const PostAuditoriaClinicaCorreccion = async (idcita, { reason_code, justification, changes }) => {
    try {
        const { data } = await BmHttp().post(`audit/clinical/appointments/${idcita}/corrections`, {
            reason_code,
            justification,
            changes,
        });
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: null, message: "Error de red" };
    }
};

// AUDITORIA-CLINICA-WORKFLOW-44: transiciones del workflow de revision.
// Ambas exigen `auditoria.clinica.correct` en backend (no se creo un permiso
// nuevo) y solo aplican a citas finalizadas.
export const PostIniciarAuditoria = async (idcita) => {
    try {
        const { data } = await BmHttp().post(`audit/clinical/appointments/${idcita}/review/start`, {});
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: null, message: "Error de red" };
    }
};

// AUD-EDIT-01: comentario general EDITABLE, versionado, independiente del
// cierre de la auditoría (ver context/67_AUD_EDIT_01_COMENTARIO_GENERAL_
// VERSIONADO.md). `GetAuditoriaClinicaComentario` trae el valor actual +
// historial completo; `PostAuditoriaClinicaComentario` SIEMPRE crea una
// versión nueva -- nunca sobreescribe una anterior, ni siquiera con la
// auditoría ya cerrada (permitido a propósito).
export const GetAuditoriaClinicaComentario = async (idcita) => {
    try {
        const { data } = await BmHttp().get(`audit/clinical/appointments/${idcita}/review/comment`);
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: null, message: "Error de red" };
    }
};

export const PostAuditoriaClinicaComentario = async (idcita, comentario) => {
    try {
        const { data } = await BmHttp().post(`audit/clinical/appointments/${idcita}/review/comment`, {
            comentario: String(comentario ?? "").trim(),
        });
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: null, message: "Error de red" };
    }
};

export const PostMarcarAuditada = async (idcita, estadoEsperado, comentario) => {
    try {
        const { data } = await BmHttp().post(`audit/clinical/appointments/${idcita}/review/complete`, {
            // Concurrencia (§30): si otro auditor ya cerro la revision entre
            // medias, el backend responde 409 en vez de pisar el cierre ajeno.
            _expected: estadoEsperado ? { estado: estadoEsperado } : undefined,
            // COMENTARIO-GENERAL: texto libre y opcional sobre la atencion en
            // conjunto. Vacio viaja como null, no como cadena vacia -- en el
            // historial se distingue "no escribio nada" de "escribio nada".
            comentario: String(comentario ?? "").trim() || null,
        });
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: null, message: "Error de red" };
    }
};
